
import { NativeTypes } from "react-dnd-html5-backend";
import { useDrop as useDrop_1, useDrag as useDrag_1 } from "react-dnd";

export const nativeType = NativeTypes;

export const useDrag = useDrag_1;

export const useDrop = useDrop_1;

export const useDropGeneric = useDrop_1;

